import script from "./patch-info-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./patch-info-panel.vue?vue&type=script&setup=true&lang=ts"

import "./patch-info-panel.vue?vue&type=style&index=0&id=68a86b5c&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68a86b5c"]])

export default __exports__